"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("./Button"));

var _utils = require("../utils");

var _getLinkIconUrl = _interopRequireDefault(require("./getLinkIconUrl.js"));

var _Theme = _interopRequireDefault(require("../../assets/Theme7.css"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _GroupItem = _interopRequireDefault(require("./GroupItem"));

var _returnIcon = _interopRequireDefault(require("../../assets/Theme7Img/returnIcon.png"));

var _dxcScrollMenu = _interopRequireDefault(require("dxc-scroll-menu"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _FontColor = _interopRequireDefault(require("./FontColor"));

var _LeftArrow = _interopRequireDefault(require("../Theme4/LeftArrow.js"));

var _rgbaToObject = _interopRequireDefault(require("../rgbaToObject.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Theme["default"]);

var CustomButton = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(CustomButton, _React$PureComponent);

  function CustomButton() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      group: null
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (menu) {
      var handleClick = _this.props.handleClick;
      handleClick && handleClick(menu);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickGroup", function (row) {
      _this.setState({
        group: row.children
      }, _this.tipRebuild);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickReturn", function () {
      _this.setState({
        group: null
      }, _this.tipRebuild);
    });

    _defineProperty(_assertThisInitialized(_this), "renderList", function (row, index) {
      var _this$props = _this.props,
          language = _this$props.language,
          disableTip = _this$props.disableTip,
          MEDIA_DOMAIN = _this$props.MEDIA_DOMAIN,
          PUBLIC_DOMAIN = _this$props.PUBLIC_DOMAIN,
          urlSplicing = _this$props.urlSplicing,
          disableLocation = _this$props.disableLocation,
          _this$props$ui = _this$props.ui,
          ui = _this$props$ui === void 0 ? {} : _this$props$ui;

      if (row.type === 0) {
        var _url = (0, _getLinkIconUrl["default"])(row, MEDIA_DOMAIN, PUBLIC_DOMAIN, urlSplicing);

        var _title = (0, _utils.getLinkTitle)(row, language);

        return /*#__PURE__*/_react["default"].createElement(_FontColor["default"], {
          key: index,
          ui: ui
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          disableTip: disableTip,
          onClick: _this.onClickGroup.bind(_assertThisInitialized(_this), row),
          src: _url
        }, _title));
      }

      var temp = row.children[0];
      if (disableLocation && temp.code === 2) return null;
      var title = (0, _utils.getLinkTitle)(temp, language);
      var url = (0, _getLinkIconUrl["default"])(row, MEDIA_DOMAIN, PUBLIC_DOMAIN, urlSplicing);
      return /*#__PURE__*/_react["default"].createElement(_FontColor["default"], {
        key: index,
        ui: ui
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: _this.onClick.bind(_assertThisInitialized(_this), temp),
        src: url
      }, title));
    });

    _defineProperty(_assertThisInitialized(_this), "tipRebuild", function () {
      var disableTip = _this.props.disableTip;
      if (disableTip) return;

      _reactTooltip["default"].rebuild();
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupList", function (row, index) {
      var _this$props2 = _this.props,
          language = _this$props2.language,
          disableTip = _this$props2.disableTip,
          _this$props2$ui = _this$props2.ui,
          ui = _this$props2$ui === void 0 ? {} : _this$props2$ui;
      var title = (0, _utils.getLinkTitle)(row, language);
      return /*#__PURE__*/_react["default"].createElement(_FontColor["default"], {
        key: index,
        ui: ui
      }, /*#__PURE__*/_react["default"].createElement(_GroupItem["default"], {
        disableTip: disableTip,
        onClick: _this.onClick.bind(_assertThisInitialized(_this), row)
      }, title));
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props3 = _this.props,
          customButton = _this$props3.customButton,
          language = _this$props3.language,
          _this$props3$ui = _this$props3.ui,
          ui = _this$props3$ui === void 0 ? {} : _this$props3$ui;
      var group = _this.state.group;

      if (group) {
        var colorObj = (0, _rgbaToObject["default"])(ui.fontColor);
        var background = "rgba(" + colorObj.r + "," + colorObj.g + "," + colorObj.b + "," + colorObj.a * 0.2 + ")";
        return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
          style: {
            background: ui.panelBgColor
          },
          vertical: "center",
          className: cx("Theme7CustomButtonWp")
        }, /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
          style: {
            color: ui.fontColor,
            background: background
          },
          onClick: _this.onClickReturn,
          vertical: "center",
          horizontal: "center",
          className: cx("Theme7Return")
        }, /*#__PURE__*/_react["default"].createElement(_LeftArrow["default"], {
          fill: ui.fontColor
        }), language === 2 ? "Return" : "返回"), /*#__PURE__*/_react["default"].createElement("div", {
          className: cx("Theme7GroupListWp")
        }, /*#__PURE__*/_react["default"].createElement(_dxcScrollMenu["default"], {
          horizontal: "left",
          data: group,
          selected: null,
          renderItem: _this.renderGroupList
        })));
      }

      return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
        style: {
          background: ui.panelBgColor
        },
        className: cx("Theme7CustomButtonWp")
      }, customButton.slice(0, 5).map(_this.renderList));
    });

    return _this;
  }

  var _proto = CustomButton.prototype;

  _proto.render = function render() {
    var _this$props4 = this.props,
        customButton = _this$props4.customButton,
        style = _this$props4.style,
        language = _this$props4.language;
    if (!customButton || customButton.length === 0) return null;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({
        width: "100%"
      }, style)
    }, this.renderContent());
  };

  return CustomButton;
}(_react["default"].PureComponent);

var _default = CustomButton;
exports["default"] = _default;
module.exports = exports.default;